import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest, HttpParams} from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuickAddTermService {

  projectId: string;
  header;
  constructor(public http: HttpClient) {
    this.projectId = localStorage.getItem('projectId');
    this.header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
  }

  newTermForm(type, projectId) {
    return this.http.get(environment.app.SERVER__URL + 'lexicon/getFormForType/projectId/'
      + projectId + '/termType/' + type);
  }

  addNewTerm(projectId, data) {
    return this.http.post(environment.app.SERVER__URL + 'lexicon/addNewTermDetails/projectId/' + projectId, data, this.header);
  }

}
